<template>
  <div>
    <div class="fixed-top">
      <LobbyNavbar />
    </div>

    <div class="container" v-if="show" style="margin-top:88px">
      <p>&zwnj;</p>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb ">
          <li class="breadcrumb-item">
            <router-link to="/Home">
              <span class="text-primary">
                Home
              </span>
            </router-link>
          </li>

          <li class="breadcrumb-item">
            <router-link to="/Products/Page=1">
              <span class="text-primary">
                Products
              </span>
            </router-link>
          </li>
          <li class="breadcrumb-item active " aria-current="page">
            {{ productInfo.ProName }}
          </li>
        </ol>
      </nav>

      <p>&zwnj;</p>

      <div class="row ">
        <div class="col-lg-6 mb-2">
          <div class="logImgFrame_proImg">
            <a :href="`//www.chanchao.com.tw/exhibitorServicefiles/products/${productInfo.ProImg}`" data-fancybox>
              <img
                :src="`//www.chanchao.com.tw/exhibitorServicefiles/products/${productInfo.ProImg}`"
                width="88%"
                style="cursor: zoom-in"
              />
            </a>
          </div>
        </div>
        <div class="col-lg-6 mb-2">
          <h3 class="mb-5">{{ productInfo.ProName }}</h3>
          <span style="font-size:17px">
            <p>
              <span class="info_size">
                Model :
              </span>
              {{ productInfo.ProModel }}
            </p>
            <p>
              <span class="info_size">
                Category :
              </span>
              {{ productInfo.CatName }}
            </p>
            <p>
              <span class="info_size">
                Exhibitor :
              </span>
              <a
                :href="`https://www.chanchao.com.tw/touchtaiwan/onlineexpo/ExhibitorDetail/${productInfo.RegNo}`"
                target="_blank"
                style="text-decoration:none;color:rgb(15 145 197)"
              >
                {{ productInfo.ComName }}
              </a>
            </p>
          </span>

          <div class="d-flex mt-4 ">
            <div>
              <div data-toggle="tooltip" data-placement="bottom" title="Remove from favorites">
                <span
                  class="badge border shadow-sm iconOpenHover"
                  v-show="productInfo.Fav == 1"
                  @click.prevent="ClickFav(ProNo)"
                  style="padding:12px"
                >
                  <img src="../../assets/images/liked.png" width="24px" alt="" />
                  <span style="font-size:14px">
                    {{ productInfo.FavCount }}
                  </span>
                </span>
              </div>

              <div data-toggle="tooltip" data-placement="bottom" title="Add to favorites">
                <span
                  class="badge border shadow-sm iconOpenHover"
                  style="padding:12px"
                  v-show="productInfo.Fav == 0"
                  @click.prevent="ClickFav(ProNo)"
                >
                  <img src="../../assets/images/like.png" width="24px" alt="" />
                  <span style="font-size:13px">
                    {{ productInfo.FavCount }}
                  </span>
                </span>
              </div>
            </div>

            <div>
              <span
                class="badge ml-4 border shadow-sm iconOpenHover"
                style="padding:12px"
                @click="openInquiryModal"
                data-toggle="tooltip"
                data-placement="bottom"
                title="Inquiry"
              >
                <img src="../../assets/images/chat9.png" width="24px" alt="" />
              </span>
            </div>
          </div>
        </div>
      </div>

      <h3 class="mt-5 mb-4 title_fontStyle title_style" v-if="r_ProDesc">Characteristic</h3>

      <p v-html="r_ProDesc"></p>

      <p>&zwnj;</p>

      <div v-if="hasOtherProNum > 0">
        <div class="recommend-title">
          <span class="recommend-content ">
            <span class="title_fontStyle" style="font-size:28px">
              Other Products
            </span>
          </span>
        </div>

        <div class="row">
          <div class="col-lg-3 my-4" v-for="item in otherProList">
            <div class="text-center bg-white pointer border card-effect" @click.prevent="goOtherProDetial(item.ProNo)">
              <div class="logImgFrame">
                <img :src="`//www.chanchao.com.tw/exhibitorServicefiles/products/${item.ProImg}`" width="60%" alt="" />
              </div>
              <div class="ProNameFrame px-1">
                <div style="height:50px; font-size:16px; font-weight:bold">
                  <div class="ellipsis_pro">
                    {{ item.ProName }}
                  </div>
                </div>
                <div class="mb-2" style="height:30px">
                  <p class="text-muted ellipsis_exh" style="font-size:12px">{{ item.ComName }}</p>
                </div>
              </div>

              <span v-show="item.Fav == 1" @click.stop="ClickFav(item.ProNo)">
                <i class="fas fa-heart"> {{ item.FavCount }}</i>
              </span>
              <span v-show="item.Fav == 0" @click.stop="ClickFav(item.ProNo)">
                <i class="far fa-heart"> {{ item.FavCount }}</i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 卡片基本資訊 -->

    <div
      class="modal fade"
      id="openInquiryModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl " role="document">
        <div class="modal-content">
          <div class="modal-header modal-title-bg">
            <h3 class="title_fontStyle ml-2">
              <img src="../../assets/images/title_chat.png" width="35px" class="mr-1" alt="" />
              Inquiry
            </h3>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body mb-2 px-4">
            <h4 class="mt-2">
              <div class="d-flex align-items-center">
                <div style="color:#514e4e">
                  <i class="fas fa-comments "></i>
                </div>
                <div class="ml-2">
                  Live Chat
                </div>
              </div>
            </h4>
            <div class="my-3" style="font-size: 21px; ">
              <div class="alert alert-warning" role="alert">
                <span class="d-none d-lg-inline">
                  <img src="../../assets/images/Chat_icon2.png" class="mr-3" width="75px" alt="" />
                </span>
                <u>*Select a representative below to start live chat</u>
                <span
                  class="d-none d-lg-inline"
                  data-toggle="tooltip"
                  data-placement="right"
                  title="Click the E-business card to start the live chat. The sign indicates the representative is available or not. If the representative is offline, you can still leave messages."
                >
                  <img src="../../assets/images/info9.png" class="ml-2" width="22px" alt="" />
                </span>
              </div>
            </div>
            <div class="row ">
              <div class="col-lg-6 mb-1 mt-3" v-for="item in CardInfo">
                <div
                  class="card bg-white profileCard shadow BusCard_Hover"
                  @click.prevent="openChatroon(item.Email, item.id)"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Click to chat"
                >
                  <div class="card-header">
                    <div class="d-flex justify-content-between">
                      <div v-if="hasChatStatue">
                        <div v-if="item.online">
                          <div class="userOnline" style="color: #35bd44;">
                            <i class="fas fa-circle mr-1"></i> Online
                          </div>
                        </div>

                        <div v-else-if="!item.online">
                          <div class="userOnline" style="color:gray;"><i class="fas fa-circle mr-1"></i> Offline</div>
                        </div>
                      </div>
                      <div class="flicker_card ml-0">
                        <img src="../../assets/images/ClickCard.png" class="mb-1" width="21px" alt="" />
                      </div>
                    </div>

                    <p>&nbsp;</p>
                  </div>

                  <div class="card-body">
                    <div class="row justify-content-between align-items-center m-2">
                      <div class="col-lg-3 ">
                        <div class="text-center text-lg-left">
                          <img
                            :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${item.Logo}`"
                            width="120px"
                            alt=""
                          />
                        </div>
                      </div>

                      <div class="col-lg-8 ">
                        <span class="PcDevice">
                          <h5 class="mb-3">{{ item.Company }}</h5>
                        </span>
                        <span class="MbDevice">
                          <h5 class="my-3">{{ item.Company }}</h5>
                        </span>
                        <p>{{ item.Dept }}</p>

                        <h5 class="mb-3 font-weight-bold">{{ item.name }}</h5>

                        <p v-if="item.Address">
                          <i class="fas fa-map-marker-alt mr-1 mb-1" style="color:#6b6766"></i> {{ item.Address }}
                        </p>
                        <p v-if="item.Tel">
                          <i class="fas fa-phone-square-alt mr-1 mb-1" style="color:#6b6766"></i> {{ item.Tel }} #{{
                            item.Ext
                          }}
                        </p>
                        <p v-if="item.Email">
                          <i class="fas fa-envelope-square mr-1 " style="color:#6b6766"></i> {{ item.Email }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <h5 class="mt-4">Or leave an inquiry here:</h5>
            <div class="btn btn-outline-primary px-4 mt-3" @click="openInquiryContent">Inquire</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 留言區資訊 -->

    <div
      class="modal fade"
      id="openInquiryContent"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl " role="document">
        <div class="modal-content">
          <div class="modal-header modal-title-bg">
            <h3 class="title_fontStyle ml-2">
              <img src="../../assets/images/title_chat.png" width="35px" class="mr-1" alt="" />
              Inquiry
            </h3>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body mb-2 px-4">
            <div class="mt-2 mb-4" style="font-size:20px">
              {{ productInfo.ComName }}
            </div>

            <div class="row">
              <div class="col-lg-6 mb-4">
                <p class="font-weight-bold" style="font-size:18px">Name</p>
                <p>{{ Username }}</p>
              </div>
              <div class="col-lg-6 mb-4">
                <p class="font-weight-bold" style="font-size:18px">Email</p>
                <p>{{ Useremail }}</p>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-6">
                <div class="form-group mb-4">
                  <label for="inputTel" class="form_title ">Tel</label>
                  <input class="form-control" type="text" id="inputTel" maxlength="30" v-model="CompanyTel" />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group mb-4">
                  <label for="inputTel" class="form_title ">Mobile</label>
                  <input class="form-control " type="text" id="inputTel" maxlength="30" v-model="allPhone" />
                </div>
              </div>
            </div>

            <div class="mb-3">
              <label for="validationTextarea" style="font-size:18px" class="font-weight-bold"
                >Content <span style="color:red">*</span></label
              >
              <textarea
                type="text"
                class="form-control"
                rows="6"
                id="validationTextarea"
                placeholder=""
                v-model="InquiryContent"
                name="Content"
                :class="{ 'is-invalid': errors.first('Content') }"
                v-validate="'required'"
              ></textarea>

              <span class="text-danger" style="font-size: 10px" v-if="errors.first('Content')">
                <i class="fas fa-exclamation-triangle"></i> The Content field is required
              </span>
            </div>
            <div class="d-flex justify-content-center">
              <div class="btn btn-primary px-4" @click.prevent="SendInquire">Send</div>
              <div v-if="hasCardInfo" class="btn btn-outline-primary px-4 ml-4" @click.prevent="returnChat">Back</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LobbyNavbar from '@/components/LobbyNavbar.vue'
  import $ from 'jquery'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      LobbyNavbar,
    },

    data() {
      return {
        productInfo: {},
        otherProList: [],
        show: false,
        r_ProDesc: '',

        ProNo: '',
        hasOtherProNum: '',
        CSRF_Token: '',

        CardInfo: [],
        hasCardInfo: false,
        Useremail: '',
        Username: '',
        CompanyTel: '',
        allPhone: '',
        InquiryContent: '',

        VerifiedCardInfo: [],
        CardInfo2: [],
        hasChatStatue: false,
        RegNo: '',
      }
    },

    methods: {
      returnChat() {
        $('#openInquiryContent').modal('hide')
        $('#openInquiryModal').modal('show')
      },

      // 打開指定即時通訊聯絡人
      openChatroon(email, id) {
        if (this.Roomvisible) {
          this.$store.dispatch('UpdateChatEmail', email)
          this.$store.dispatch('ShowChatRoom', true)
        } else {
          this.$store.dispatch('Updatevisible', true)
          this.$store.dispatch('UpdateChatEmail', email)
          this.$store.dispatch('ShowChatRoom', true)
        }

        const vm = this

        let NowPageUrl = location.href
        let OpenCardURL = `${NowPageUrl}#card`

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: 'card',
          ID: id,
          Url: OpenCardURL,
          CSRF: vm.CSRF_Token,
          RegNo: vm.RegNo,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            console.log('Log success')
          } else if (response.data == '251') {
            console.log('Log fail')
          }
        })

        $('#openInquiryModal').modal('hide')
      },

      openInquiryModal() {
        if (this.hasCardInfo) {
          $('#openInquiryModal').modal('show')

          const vm = this

          let NowPageUrl = location.href
          let OpenCardURL = `${NowPageUrl}#card`

          const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
          const info = {
            Type: '',
            ID: '',
            Url: OpenCardURL,
            CSRF: vm.CSRF_Token,
            RegNo: vm.RegNo,
          }
          vm.$http.post(url, info).then(function(response) {
            if (response.data == '200') {
              console.log('Log success')
            } else if (response.data == '251') {
              console.log('Log fail')
            }
          })
        } else {
          $('#openInquiryContent').modal('show')
          const vm = this

          let NowPageUrl = location.href
          let OpenInquireURL = `${NowPageUrl}#inquiry`

          const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
          const info = {
            Type: '',
            ID: '',
            Url: OpenInquireURL,
            CSRF: vm.CSRF_Token,
            RegNo: vm.RegNo,
          }
          vm.$http.post(url, info).then(function(response) {
            if (response.data == '200') {
              console.log('Log success')
            } else if (response.data == '251') {
              console.log('Log fail')
            }
          })
        }
      },

      openInquiryContent() {
        $('#openInquiryModal').modal('hide')
        $('#openInquiryContent').modal('show')

        const vm = this

        let NowPageUrl = location.href
        let OpenInquireURL = `${NowPageUrl}#inquiry`

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: OpenInquireURL,
          CSRF: vm.CSRF_Token,
          RegNo: vm.RegNo,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            console.log('Log success')
          } else if (response.data == '251') {
            console.log('Log fail')
          }
        })
      },

      //reget profavo status
      getPro(id) {
        const vm = this
        vm.$http
          .get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/ProductsDetail/${vm.exhcode}/${id}?Lang=en`)
          .then((response) => {
            vm.productInfo = response.data
          })
      },

      goOtherProDetial(id) {
        const vm = this
        vm.$router.push(`/ProductDetail/${id}`)
        vm.getProDetial(id)
        vm.ProNo = id
      },

      getProDetial(id) {
        const vm = this

        vm.show = false
        vm.$store.dispatch('updateLoading', true)

        vm.$http
          .get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/ProductsDetail/${vm.exhcode}/${id}?Lang=en`)
          .then((response) => {
            console.log(response.data)

            vm.productInfo = response.data
            vm.RegNo = response.data.RegNo
            vm.r_ProDesc = response.data.ProDesc

            //取得相似產品
            vm.$http
              .get(
                `https://www.chanchao.com.tw/apiOnlineExpo/v1/OtherProducts/${vm.exhcode}/${vm.productInfo.RegNo}/${id}?Lang=en`
              )
              .then((response) => {
                console.log(response.data)
                vm.otherProList = response.data
                vm.hasOtherProNum = vm.otherProList.length
                vm.show = true

                vm.$store.dispatch('updateLoading', false)
              })

            //取得攤位人員資料
            vm.$http
              .get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/Boothstaff/${vm.productInfo.RegNo}`)
              .then((response) => {
                vm.hasChatStatue = false

                vm.VerifiedCardInfo = response.data.filter((item) => {
                  return item.Verified == 1
                })

                vm.CardInfo = vm.VerifiedCardInfo
                vm.CardInfo2 = vm.VerifiedCardInfo

                if (vm.CardInfo.length > 0) {
                  vm.hasCardInfo = true
                  vm.show = true
                } else {
                  vm.hasCardInfo = false
                  vm.show = true
                }

                for (let i = 0; i < vm.CardInfo2.length; i++) {
                  vm.$http
                    .get(
                      `https://www.chanchao.com.tw/apiOnlineExpo/v1/Boothstaffonline?id=${vm.CardInfo2[i].Email}&group=df2242f61b11d1929128800348ba5a45`
                    )
                    .then((response) => {
                      vm.CardInfo2[i].online = response.data

                      vm.hasChatStatue = vm.CardInfo2.every(function(item) {
                        return item.online !== undefined
                      })

                      if (vm.hasChatStatue) {
                        vm.CardInfo = vm.CardInfo2
                      }
                    })
                }
              })
          })

        // 取得自身資料
        vm.$http.get('https://www.chanchao.com.tw/apiRegister/v1/regInformation').then((response) => {
          vm.Useremail = response.data.email
          vm.Username = response.data.cname

          if (response.data.Ext) {
            vm.CompanyTel = response.data.Tel + '#' + response.data.Ext
          } else {
            vm.CompanyTel = response.data.Tel
          }

          //手機組合

          let mobilenum = response.data.mobile
          let mobArea = response.data.MobileCountryCode
          vm.allPhone = mobArea + mobilenum
        })

        //紀錄瀏覽

        vm.$http.get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/CSRF_Token`).then((response) => {
          let CSRFToken = response.data
          vm.CSRF_Token = response.data

          let NowPageUrl = location.href

          const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
          const info = {
            Type: 'PID',
            ID: vm.$route.params.MyProId,
            Url: NowPageUrl,
            CSRF: CSRFToken,
          }

          vm.$http.post(url, info).then(function(response) {
            if (response.data == '200') {
              console.log('Log success')
            } else if (response.data == '251') {
              console.log('Log fail')
            }
          })
        })
      },

      // 傳詢問問題
      SendInquire() {
        const vm = this

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/Inquire/${vm.exhcode}`
        const info = {
          exhcode: vm.exhcode,
          CSRF: vm.CSRF_Token,
          CName: vm.Username,
          Email: vm.Useremail,
          Tel: vm.CompanyTel,
          Mobile: vm.allPhone,
          Inquiry: vm.InquiryContent,
          Type: 'PID',
          ID: vm.ProNo,
        }

        vm.$validator.validate().then((valid) => {
          if (valid) {
            vm.$http.post(url, info).then(function(response) {
              if (response.data == '200') {
                vm.alertTitle = 'Success'
                vm.alertText = 'Your inquiry has been sent'

                vm.alertSuccess()
              } else if (response.data == '252') {
                window.location.replace(`https://www.chanchao.com.tw/en/`)
              } else if (response.data == '251') {
                vm.alertText = 'Server is busy, please try again later.'

                vm.alertError()
              } else if (response.data == '253') {
                vm.alertText = ' Email error'
                vm.alertError()
              }
            })
          } else {
            vm.alertText = 'Your request could not be completed.'
            vm.alertError()
          }
        })
      },

      //點喜愛產品
      ClickFav(ProNo) {
        const vm = this
        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/FavoritesProducts/${vm.exhcode}/${ProNo}`

        const info = {
          CSRF: vm.CSRF_Token,
        }

        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            vm.getPro(ProNo)
            vm.$bus.$emit('message:push', 'Added to favorites', 'warning')
          } else if (response.data == '252') {
            window.location.replace(`https://www.chanchao.com.tw/en/`)
          } else if (response.data == '251') {
            vm.alertText = 'Server is busy, please try again later.'

            vm.alertError()
          } else if (response.data == '253') {
            vm.getPro(ProNo)
            vm.$bus.$emit('message:push', 'Removed from favorites', 'danger')
          }
        })
      },

      alertSuccess() {
        const vm = this
        vm.$swal({
          title: vm.alertTitle,
          text: vm.alertText,
          icon: 'success',
          confirmButtonText: 'OK',

          confirmButtonColor: '#abc6d2',
          width: 300,
          padding: 15,
        }).then(function() {
          if (vm.hasCardInfo) {
            vm.InquiryContent = ''

            $('#openInquiryContent').modal('hide')
            $('#openInquiryModal').modal('show')

            const vm = this

            let NowPageUrl = location.href
            let OpenCardURL = `${NowPageUrl}#card`

            const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
            const info = {
              Type: '',
              ID: '',
              Url: OpenCardURL,
              CSRF: vm.CSRF_Token,
              RegNo: vm.RegNo,
            }
            vm.$http.post(url, info).then(function(response) {
              if (response.data == '200') {
                console.log('Log success')
              } else if (response.data == '251') {
                console.log('Log fail')
              }
            })
          } else {
            vm.InquiryContent = ''

            $('#openInquiryContent').modal('hide')
          }
        })
      },

      alertError() {
        const vm = this
        vm.$swal({
          text: vm.alertText,
          icon: 'info',
          confirmButtonText: 'OK',

          allowOutsideClick: true,
          confirmButtonColor: '#abc6d2',
          width: 300,
          padding: 15,
        })
      },

      alertCancelFav() {
        const vm = this
        vm.$swal({
          text: vm.alertText,
          icon: 'info',
          confirmButtonText: 'OK',

          allowOutsideClick: true,
          confirmButtonColor: '#abc6d2',
          width: 300,
          padding: 15,
        }).then(function() {
          window.location.replace(`https://www.chanchao.com.tw/touchtaiwan/onlineexpo/ProductDetail/${vm.ProNo}`)
        })
      },

      alertFavSuccess() {
        const vm = this

        vm.$swal({
          title: vm.alertTitle,
          text: vm.alertText,
          icon: 'success',
          confirmButtonText: 'OK',

          confirmButtonColor: '#abc6d2',
          width: 300,
          padding: 15,
        }).then(function() {
          $('#SettingModal').modal('hide')
          window.location.replace(`https://www.chanchao.com.tw/touchtaiwan/onlineexpo/ProductDetail/${vm.ProNo}`)
        })
      },
    },

    computed: {
      ...mapGetters(['ListStatus', 'Roomvisible', 'ShowRoom', 'exhcode']),
    },
    created() {
      $('.modal').modal('hide')

      this.$store.dispatch('ShowChatRoom', false)

      this.$store.dispatch('updateList', false)
      this.$store.dispatch('Updatevisible', true)

      const vm = this

      vm.$store.dispatch('updateLoading', true)

      vm.ProNo = vm.$route.params.MyProId

      $(function() {
        $('#openInquiryContent').on('hide.bs.modal', function() {
          vm.InquiryContent = ''
        })
      })

      //取得產品詳細資料
      vm.$http
        .get(
          `https://www.chanchao.com.tw/apiOnlineExpo/v1/ProductsDetail/${vm.exhcode}/${vm.$route.params.MyProId}?Lang=en`
        )
        .then((response) => {
          vm.productInfo = response.data
          vm.RegNo = response.data.RegNo
          console.log(vm.RegNo)
          vm.r_ProDesc = response.data.ProDesc

          //取得攤位人員資料
          vm.$http
            .get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/Boothstaff/${vm.productInfo.RegNo}`)
            .then((response) => {
              vm.VerifiedCardInfo = response.data.filter((item) => {
                return item.Verified == 1
              })

              vm.CardInfo = vm.VerifiedCardInfo
              vm.CardInfo2 = vm.VerifiedCardInfo

              if (vm.CardInfo.length > 0) {
                vm.hasCardInfo = true
                vm.show = true
              } else {
                vm.hasCardInfo = false
                vm.show = true
              }

              for (let i = 0; i < vm.CardInfo2.length; i++) {
                vm.$http
                  .get(
                    `https://www.chanchao.com.tw/apiOnlineExpo/v1/Boothstaffonline?id=${vm.CardInfo2[i].Email}&group=df2242f61b11d1929128800348ba5a45`
                  )
                  .then((response) => {
                    vm.CardInfo2[i].online = response.data

                    vm.hasChatStatue = vm.CardInfo2.every(function(item) {
                      return item.online !== undefined
                    })

                    if (vm.hasChatStatue) {
                      vm.CardInfo = vm.CardInfo2
                    }
                  })
              }
            })

          //取得相似產品
          vm.$http
            .get(
              `https://www.chanchao.com.tw/apiOnlineExpo/v1/OtherProducts/${vm.exhcode}/${vm.productInfo.RegNo}/${vm.$route.params.MyProId}?Lang=en`
            )
            .then((response) => {
              vm.otherProList = response.data
              vm.hasOtherProNum = vm.otherProList.length
              vm.show = true

              vm.$store.dispatch('updateLoading', false)
            })
        })

      // 取得自身資料
      vm.$http.get('https://www.chanchao.com.tw/apiRegister/v1/regInformation').then((response) => {
        vm.Useremail = response.data.email
        vm.Username = response.data.cname

        if (response.data.Ext) {
          vm.CompanyTel = response.data.Tel + '#' + response.data.Ext
        } else {
          vm.CompanyTel = response.data.Tel
        }

        //手機組合

        let mobilenum = response.data.mobile
        let mobArea = response.data.MobileCountryCode
        vm.allPhone = mobArea + mobilenum
      })

      //紀錄瀏覽

      vm.$http.get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/CSRF_Token`).then((response) => {
        let CSRFToken = response.data
        vm.CSRF_Token = response.data

        let NowPageUrl = location.href

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: 'PID',
          ID: vm.$route.params.MyProId,
          Url: NowPageUrl,
          CSRF: CSRFToken,
        }

        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            console.log('Log success')
          } else if (response.data == '251') {
            console.log('Log fail')
          }
        })
      })
    },
  }
</script>
<style lang="scss" scoped>
  .ellipsis_pro {
    font-size: 16px;
    font-weight: bold;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
  }

  .ellipsis_exh {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
  }

  .logImgFrame {
    width: 230px;
    height: 170px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .logImgFrame_proImg {
    width: 400px;
    min-height: 350px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 555px) {
    .logImgFrame_proImg {
      width: 390px;
      min-height: 350px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .card {
    -webkit-box-shadow: -1px 1px 24px -7px rgba(92, 89, 92, 0.09);
    -moz-box-shadow: -1px 1px 24px -7px rgba(92, 89, 92, 0.09);
    box-shadow: -1px 1px 24px -7px rgba(92, 89, 92, 0.09);
    min-height: 310px;

    @media (max-width: 576px) {
      min-height: 240px;

      .modal-content {
        height: auto;
      }
    }
  }

  .modal-content {
    height: 82vh;
    overflow-y: hidden;
  }

  .modal-body {
    overflow-y: scroll;
  }

  .ProImg_relative {
    position: relative;
  }

  .zoominIcon {
    position: absolute;
    right: 0px;
    color: #403e3e61;
    font-size: 25px;
  }

  .card-header {
    margin-bottom: 0;
    background-color: #dadddd;
    border-bottom: 0px;
    position: relative;
  }

  .iconOpenHover {
    transition: all 0.3s ease;
    cursor: pointer;

    &:hover {
      transform: scale(1.1);
    }
  }
</style>
